import React, { useEffect,useState } from 'react';
import mgmtVariant from 'src/services/mgmtVariant';

import { DataGrid } from '@mui/x-data-grid';

import PropTypes from 'prop-types';

import Delete from '@mui/icons-material/Delete';
import { GridRowModes } from '@mui/x-data-grid';

import axios from 'src/utils/axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Box,
  IconButton,
  SvgIcon,
  CircularProgress,
} from '@mui/material';

import {
  Edit as EditIcon,
} from 'react-feather';

import { useDispatch, useSelector } from 'react-redux';

// Action
import { fetchVariantProducts } from 'src/actions/mgmtVariantAction';

function Results({ className, customerId, categoryId, ...rest }) {
    const [rowModesModel, setRowModesModel] = useState({});

  const dispatch = useDispatch();
  // Redux State
  const variants = useSelector((state) => {

    const list = state?.variant?.variants || [];

    return [...list].reverse();

  });

  // Fetch Variants
  useEffect(() => {

    dispatch(fetchVariantProducts(customerId, categoryId));

  }, [customerId, categoryId]);

  // Delete Variant
  const handleDelete = async (productVariantId) => {

    try {

      await axios.delete( `/api/admin/catalog/product/variant?productVariantId=${productVariantId}` );

      dispatch(fetchVariantProducts(customerId, categoryId));

    } catch (err) {

      console.error('Error deleting variant:', err);

    }
  };
const processRowUpdate = async (newRow) => {
  try {
    const payload = {
      customerId: newRow.customerId,
      baseProductId: newRow.baseProductId,
      productVariantId: newRow.productVariantId,
      variantName: newRow.variantName,
      variantSKU: newRow.variantSKU,
      availableStock: newRow.availableStock,
      minStock: newRow.minStock,
      description: newRow.description
    };
    await mgmtVariant.updateVariant(payload);
    return newRow;

  } catch (error) {
    return newRow;

  }
};
const [openDialog, setOpenDialog] = useState(false);

const [variantForm, setVariantForm] = useState({
  baseProductId: "",
  variantName: "",
  variantSKU: "",
  weight: "",
  size: "",
  sellPrice: "",
  availableStock: "",
  description: ""
});


  // Table Columns
  const columns = [

    {
      field: 'productVariantId',
      headerName: 'Variant Id',
      width: 140
    },
   {
  field: 'actions',
  headerName: 'Action',
  width: 180,

  renderCell: (params) => {

    const isInEditMode =
      rowModesModel[params.row.productVariantId]?.mode === 'edit';

    if (isInEditMode) {
      return (
        <>
          <IconButton
  onClick={async () => {

    const payload = {
      customerId: params.row.customerId,
      baseProductId: params.row.baseProductId,
      productVariantId: params.row.productVariantId,
      variantName: params.row.variantName,
      variantSKU: params.row.variantSKU,
      availableStock: params.row.availableStock,
      minStock: params.row.minStock,
      description: params.row.description
    };

    const formData = new FormData();

    formData.append(
      "productData",
      JSON.stringify(payload)
    );

    try {

      await mgmtVariant.updateVariant(formData);

      console.log("Update Success");

      dispatch(
        fetchVariantProducts(
          customerId,
          categoryId
        )
      );

    } catch (error) {

      console.log(
        "Update Error",
        error.response?.data
      );

    }

    setRowModesModel({
      ...rowModesModel,
      [params.row.productVariantId]: {
        mode: 'view'
      }
    });

  }}
>
  <SaveIcon />
</IconButton>

          <IconButton
            onClick={() =>
              setRowModesModel({
                ...rowModesModel,
                [params.row.productVariantId]: {
                  mode: 'view',
                  ignoreModifications: true
                }
              })
            }
          >
            <CloseIcon />
          </IconButton>
        </>
      );
    }

    return (
      <>
        <IconButton
          onClick={() =>
            setRowModesModel({
              ...rowModesModel,
              [params.row.productVariantId]: { mode: 'edit' }
            })
          }
        >
          <SvgIcon fontSize="small">
            <EditIcon />
          </SvgIcon>
        </IconButton>

        <IconButton
          onClick={() =>
            handleDelete(
              params.row.productVariantId
            )
          }
        >
          <Delete />
        </IconButton>
      </>
    );
  }
},

    {
      field: 'variantName',
      headerName: 'Variant Name',
      width: 220,
      editable: true
    },

    {
      field: 'variantSKU',
      headerName: 'Variant SKU',
      width: 200,
      editable: true
    },

    // SIZE
    {
      field: 'size',
      headerName: 'Size',
      width: 120,
      editable: false,

      valueGetter: (params) => {

        const sizeObj =
          params.row.variations?.find(
            (item) => item.size
          );

        return sizeObj?.size || '-';

      }
    },

    // WEIGHT
    {
      field: 'weight',
      headerName: 'Weight',
      width: 140,
      editable: false,

      valueGetter: (params) => {

        const weightObj =
          params.row.variations?.find(
            (item) =>
              item.weight || item.WEIGHT
          );

        return (
          weightObj?.weight ||
          weightObj?.WEIGHT ||
          '-'
        );

      }
    },

    // AVAILABLE STOCK
    {
      field: 'availableStock',
      headerName: 'Available Stock',
      width: 170,
      editable: true
    },

    // MIN STOCK
    {
      field: 'minStock',
      headerName: 'Min Stock',
      width: 140,
      editable: true
    },

    {
      field: 'baseProductId',
      headerName: 'Base Product Id',
      width: 180,
      editable: true
    },

    {
      field: 'metrics',
      headerName: 'Metrics',
      width: 120,
      editable: true
    },

    {
      field: 'price',
      headerName: 'Price',
      width: 120,
      editable: false,

      valueGetter: (params) => {

        return params.row.price?.sellPrice || 0;

      }
    },

    {
      field: 'customerId',
      headerName: 'Customer Id',
      width: 140,
      editable: true
    },

    {
      field: 'description',
      headerName: 'Description',
      width: 250,
      editable: true
    },

  ];

  // Loading
  if (!variants) {

    return (

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 400
        }}
      >

        <CircularProgress />

      </Box>

    );
  }

return (
  <>
    <Box sx={{ height: 600, width: '100%' }}>

      <Box
        sx={{
          mb: 2,
          display: "flex",
          justifyContent: "flex-end"
        }}
      >
      <Button
  variant="contained"
  onClick={() => {
    setVariantForm({
      ...variantForm,
      baseProductId: variants?.[0]?.baseProductId || ""
    });

    setOpenDialog(true);
  }}
>
  + Add Variant
</Button>
      </Box>

      <DataGrid
        rows={variants}
        columns={columns}
        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={setRowModesModel}
        processRowUpdate={processRowUpdate}
        getRowId={(row) => row.productVariantId}
        pageSize={8}
        rowsPerPageOptions={[8]}
      />

    </Box>

    <Dialog
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Add Variant</DialogTitle>

      <DialogContent>
<TextField
  fullWidth
  margin="normal"
  label="Base Product Id"
  value={variantForm.baseProductId}
  onChange={(e) =>
    setVariantForm({
      ...variantForm,
      baseProductId: e.target.value
    })
  }
/>

        <TextField
          fullWidth
          margin="normal"
          label="Variant Name"
          value={variantForm.variantName}
          onChange={(e) =>
            setVariantForm({
              ...variantForm,
              variantName: e.target.value
            })
          }
        />

        <TextField
          fullWidth
          margin="normal"
          label="Variant SKU"
          value={variantForm.variantSKU}
          onChange={(e) =>
            setVariantForm({
              ...variantForm,
              variantSKU: e.target.value
            })
          }
        />

        <TextField
          fullWidth
          margin="normal"
          label="Weight"
          value={variantForm.weight}
          onChange={(e) =>
            setVariantForm({
              ...variantForm,
              weight: e.target.value
            })
          }
        />

        <TextField
          fullWidth
          margin="normal"
          label="Price"
          type="number"
          value={variantForm.sellPrice}
          onChange={(e) =>
            setVariantForm({
              ...variantForm,
              sellPrice: e.target.value
            })
          }
        />

        <TextField
          fullWidth
          margin="normal"
          label="Available Stock"
          type="number"
          value={variantForm.availableStock}
          onChange={(e) =>
            setVariantForm({
              ...variantForm,
              availableStock: e.target.value
            })
          }
        />

        <TextField
          fullWidth
          margin="normal"
          label="Description"
          multiline
          rows={3}
          value={variantForm.description}
          onChange={(e) =>
            setVariantForm({
              ...variantForm,
              description: e.target.value
            })
          }
        />

      </DialogContent>

      <DialogActions>

        <Button
          onClick={() => setOpenDialog(false)}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
         onClick={async () => {

  try {

    const productData = {
      customerId: customerId,
      baseProductId: Number(
variantForm.baseProductId
  ),
      variantName: variantForm.variantName,
      variantSKU: variantForm.variantSKU,
      variations: [
        {
          weight: variantForm.weight
        }
      ],
      price: {
        sellPrice: Number(
          variantForm.sellPrice
        )
      },
      description:
        variantForm.description,
      availableStock: Number(
        variantForm.availableStock
      )
    };

    const formData = new FormData();

    formData.append(
      "productData",
      JSON.stringify(productData)
    );

    const response =
      await mgmtVariant.addVariant(
        formData
      );

    setOpenDialog(false);

    dispatch(
      fetchVariantProducts(
        customerId,
        categoryId
      )
    );

  } catch (err) {

    console.error(
      "Add Variant Error",
      err.response?.data || err
    );

  }

}}
        >
          Save
        </Button>

      </DialogActions>

    </Dialog>
  </>
);
}

Results.propTypes = {
  className: PropTypes.string,
};

Results.defaultProps = {};

export default Results;